module.exports = __webpack_public_path__ + "static/images/75fd3f9cf0f51580f8f2adfa7cc7af61.webp";